export default __webpack_public_path__ + "static/media/rmcm02.7383d30a.png";